"use client";
import { FaRegDotCircle } from "react-icons/fa";

import Link from "next/link";
import { usePathname } from "next/navigation";

const ActiveLink = ({ href, children }) => {
  const pathName = usePathname();
  const isActive = pathName === href;
  return (
    <Link href={href}>
      <span
        className={`${
          isActive
            ? "flex justify-center items-center border-t border-black pointer-events-none"
            : "uppercase"
        } uppercase`}
      >
        {children}
        {isActive && (
          <FaRegDotCircle className="text-black text-lg pt-1 -left-4" />
        )}
      </span>
    </Link>
  );
};

export default ActiveLink;
